import { render } from "./resetPasword.vue?vue&type=template&id=4d3943d2"
import script from "./resetPasword.vue?vue&type=script&lang=js"
export * from "./resetPasword.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__